var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('div',{staticClass:"channel"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.channelTitle))])]),_vm._l((_vm.tabArr),function(item){return _c('div',[_c('PopForm',{attrs:{"popDataitem":item,"isAllbtn":_vm.isAllbtn},on:{"passThrough":_vm.passThrough,"sendBack":_vm.sendBack}})],1)})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }